import { BreadcrumbRoute } from '@foxtrotplatform/platform-micro-site-core';
import { Outlet } from 'react-router-dom';

import { Final } from './components/sign-up/finalize/Finalize';
import { Billing } from './components/sign-up/Billing';
import { TaxIndiaFormComponent } from './components/sign-up/TaxIndiaForm';
import { OrgDetailsComponent } from './components/sign-up/OrgDetails';
import { SelectPlanComponent } from './components/sign-up/selectPlan/SelectPlan';
import { VerifyEmailComponent } from './components/sign-up/VerifyEmailComponent';

export const routes: BreadcrumbRoute[] = [
  {
    element: <Outlet />,

    children: [
      {
        path: 'create-org',
        element: <OrgDetailsComponent />,
      },
      { path: 'tax', element: <TaxIndiaFormComponent /> },
      { path: 'billing', element: <Billing /> },
      { path: 'finalize', element: <Final /> },
      {
        path: 'plan',
        element: <SelectPlanComponent />,
      },
      {
        index: true,
        element: <VerifyEmailComponent />,
      },
    ] as BreadcrumbRoute[],
  },
];
